import { styled } from '@mui/system';

import { Box, Typography, Paper } from '@mui/material';
import { JourneyButtonContainer } from '../StorySection/styles';
import { fontFamilies } from '../../../../../constants/theme';
import { SectionHeading } from '../../../../../ui/typography';

export const MissionSectionWrapper = styled(Box)(({ theme }) => ({
  margin: '0',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.up('md')]: {
    maxHeight: '420px',
  },
}));

export const MissionContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'center',
  width: '100%',
  gap: '40px',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '5fr 7fr',
    gap: '60px',
    maxWidth: '1100px',
    margin: '0 auto',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '100px',
  },
}));

export const MissionLeftColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    textAlign: 'center',
  },
  [theme.breakpoints.up('md')]: {
    height: '100%',
    alignItems: 'flex-start',
    marginTop: '115px',
    gap: '0',
  },
}));

export const MissionTitle = styled(SectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: '-1.2px',
  margin: '0 auto 30px 0',
  [theme.breakpoints.down('md')]: {
    margin: '0 auto 0',
  },
}));

export const MissionText = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '26px',
  },
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    fontSize: '18px',
    lineHeight: '28px',
    margin: '23px 0 0 0',
    letterSpacing: '-0.5px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '22px',
    lineHeight: '32px',
    letterSpacing: '-0.7px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
    margin: '0',
  },
}));

export const MissionButtonContainer = styled(JourneyButtonContainer)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    marginTop: '30px',
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '45px',
  },
}));

export const MissionRightColumn = styled(Box)({});

export const CommitmentTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  fontSize: '18px',
  lineHeight: '26px',
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    fontSize: '20px',
    lineHeight: '28px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '22px',
    lineHeight: '23px',
    minWidth: '550px',
  },
}));

export const CommitmentsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  [theme.breakpoints.up('md')]: {
    gap: '14px',
  },
}));

export const StyledCommitmentPill = styled(Paper)(({ theme }) => ({
  padding: '18px',
  borderRadius: '23px',
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  backgroundColor: 'background.paper',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  fontWeight: 400,
  fontSize: '15px',
  lineHeight: '22px',
  whiteSpace: 'pre-line',
  textAlign: 'left',
  '& .MuiSvgIcon-root': {
    height: '34px',
    width: '28px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '18px',
    lineHeight: '25px',
  },
}));
